import { CpNativeAppIntegration } from "../nativeapps/CpNativeAppIntegration.js";
import { DetectedWebView } from "@ciaopeople/cp-shatsu/ClientDetection";
import { APIClientInterface } from "../api/APIClientInterface.js";
import { ApplicationAccessTokenConfig, PropertyConfig } from "../config/PropertyConfig.js";
import { DirectLoginManagerConfig } from "@api-commons/login/DirectLoginManagerConfig.js";
import {GSIGoogleLogin} from "../login/direct_providers/GSIGoogleLogin.js";
import { SessionStorageInterface } from "@api-commons/session/SessionStorageInterface.js";
//import { FacebookLogin, FacebookLoginMixedImpl } from "../login";
import { DirectLoginManager } from "../login/DirectLoginManager.js";
import { AppleLogin } from "../login/direct_providers/AppleLogin.js";
import { FirebaseWrapper } from "../login/direct_providers/FirebaseWrapper.js";
import { FirstPartyEmailLogin } from "../login/direct_providers/FirstPartyEmailLogin.js";
import { GoogleLoginOneTapDelegate } from "../login/direct_providers/GoogleLoginOneTapDelegate.js";
import { LoginProvider } from "../login/direct_providers/LoginProvider.js";
import { StatsCollector } from "../stats/StatsCollector.js";
import { ApplicationUrlHandler } from "./modules/ApplicationUrlHandler.js";
import { PostMessageProxyPromise } from "@ciaopeople/cp-shatsu/RemoteService";
import { FacebookManualFlowLocalPart } from "../login/direct_providers/fbmanual/FacebookManualFlowLocalPart.js";
import { GSILoader } from "@api-commons/login/direct_providers/commons/GSILoader.js";
import { DeviceIdProvider } from "@api-commons/utils/DeviceIdProvider.js";


let myGsiLoader: GSILoader = null;

function removeStartingDot(text: string): string {
    return text.charAt(0) == "." ? text.substring(1) : text;
}

function buildLoginManagerConfig(srvconfig: PropertyConfig, app_token:string): DirectLoginManagerConfig {

    return {
        actual_providers: srvconfig.loginManager.actual_providers,
        firebase: srvconfig.loginManager.firebase,
        general:{
            app_token: app_token,
            firebaseAccountMergeEnable: srvconfig.loginManager.firebaseAccountMergeEnable
        },
        autologin: srvconfig.loginManager.autologin,
        revokeOnClientSideOnDeletion: srvconfig.loginManager.revokeOnClientSideOnDeletion,
        mainUrl: srvconfig.mainUrl
    };
}
function configureAndIncludeLoginProviders(config: PropertyConfig, 
    urlHandler: ApplicationUrlHandler, 
    proxy: PostMessageProxyPromise, 
    sessionStorage: SessionStorageInterface, 
    gsiloader: GSILoader,
    //emailLoginDialogControls: ContextualEmailLoginDialogControls
): LoginProvider[] {
    
    const provconf = config.loginManager.actual_providers;
    const providers = [];
    if(provconf) {
        if(provconf.facebook && provconf.facebook.enabled) {
            const localpart = new FacebookManualFlowLocalPart(proxy, sessionStorage, config.cookies.names, provconf.facebook.applicationIdentifier,
                "https://" + config.host + "/redirect/fb", provconf.facebook.scopes);
            providers.push(localpart);
            // const sdkpart = new FacebookLogin(
            //     provconf.facebook.applicationIdentifier
            // );
            // providers.push(new FacebookLoginMixedImpl(sdkpart,localpart));       
        }
        if(provconf.google && provconf.google.enabled) {
            providers.push(new GoogleLoginOneTapDelegate(provconf.google.applicationIdentifier));
            providers.push(new GSIGoogleLogin(gsiloader, provconf.google.scopes));
        }
        if(provconf.apple && provconf.apple.enabled) {
            const firebaseWrapper = new FirebaseWrapper(config.loginManager.firebase);
            //firebaseWrapper.auth();
            providers.push(new AppleLogin(firebaseWrapper, provconf.apple.scopes));
        }
        if(provconf.email && provconf.email.enabled) {
            // const emailProvider = new FirstPartyEmailLogin("https://" + config.host + "/rest/v1/email/auth/dialog", 
            //     provconf.email.codeLoginAllowed?provconf.email.codeLoginAllowed:false,
            //     provconf.email.codeLoginAllowed?emailLoginDialogControls:null
            // );
            const emailProvider = new FirstPartyEmailLogin("https://" + config.host + "/rest/v1/email/auth/dialog")
            providers.push(emailProvider);            

        }
    }
    return providers;

}

function selectAccessTokenAccordingly(tokenParam: ApplicationAccessTokenConfig, userAgentParsed: DetectedWebView) {

    if(userAgentParsed && userAgentParsed.native_app) {
        if(userAgentParsed.platform.ios) return tokenParam.ios;
        else return tokenParam.android;
    }
    else return tokenParam.web;

}
export function getGSILoader(config: PropertyConfig) {
    if(myGsiLoader == null) {
        if("google" in config.loginManager.actual_providers) {
            myGsiLoader = new GSILoader(
                config.loginManager.actual_providers.google.applicationIdentifier,
                removeStartingDot(config.cookies.cookieDomain)
            );
        }
    }
    return myGsiLoader;
}

export function directLoginManagerBuilder(config: PropertyConfig, 
    sessionStorage: SessionStorageInterface, 
    statsCollector: StatsCollector,
    api: APIClientInterface,
    detectedWebview: DetectedWebView,
    nativeAppIntegration: CpNativeAppIntegration,
    deviceIdProvider: DeviceIdProvider,
    urlHandler: ApplicationUrlHandler,
    proxy: PostMessageProxyPromise,
    gsiLoader: GSILoader,
    //emailLoginDialogControls: ContextualEmailLoginDialogControls
): DirectLoginManager {
    const dlmConfig = buildLoginManagerConfig(config, 
        selectAccessTokenAccordingly(config.applicationToken, detectedWebview));
        
    return new DirectLoginManager(dlmConfig, 
        configureAndIncludeLoginProviders(config, urlHandler,
        proxy, sessionStorage, gsiLoader
        //,emailLoginDialogControls
        ),
        sessionStorage,
        statsCollector,
        api,
        nativeAppIntegration,
        deviceIdProvider,
    );
}


